import styled from 'styled-components'

export const InputStyle = styled.input`
  background: #F6F9F6;
  border-radius: 30px;
  border: none;
  width: 280px;
  height: 33px;
  padding: 0px 16px;
`